import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  selectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  unselectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }
}
